import { UPDATE_USER_WINNER_PRIZE } from 'client/redux/modules/userWinnerPrize';

const UPDATE_FLAGS = 'flags/UPDATE_FLAGS';
const UPDATE_PARTICIPANT_PRIZE_POPUP = 'flags/UPDATE_PARTICIPANT_PRIZE_POPUP';

export const PICK_PRIZE_CUSTOM_PRIZE_UUID = 'PICK_PRIZE_CUSTOM_PRIZE_UUID';

const defaultState = {
    hasInited: false,
    hasErrorOnInit: false,
    hasUserStateInited: false,
    // true: 已經拿到最新的 winner 資料，不用打API更新已配獎獎項名單
    hasUserWinnerPrizeListReady: true,
    isPrizeListOpen: false,
    // 領獎 Popup 資料，prizeUUID 用來打 API 拿到 prize info，entryUUID 用來當作跳轉到 Prize 頁的網址參數
    participantPrizePopup: {
        isNoGetPrize: false,
        entryUUID: '',
        prizeUUID: ''
    },
    // 若當純獎模組被當成獎項，配獎時前往 Lottery 頁面時，animatingLotteries會被賦予值去記錄現在正在執行什麼動畫
    animatingLotteries: {
        type: '',
        uuid: '',
        animationSettings: {}
    },
    // 是否為再次參加
    isReJoin: false,
    isMgmShare: false,
    isMgmMission: false,
    isMgmSelf: false
};
const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_USER_WINNER_PRIZE: {
            return { ...state, hasUserWinnerPrizeListReady: true };
        }
        case UPDATE_PARTICIPANT_PRIZE_POPUP: {
            return {
                ...state,
                participantPrizePopup: { ...state.participantPrizePopup, ...action.payload }
            };
        }
        case UPDATE_FLAGS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

// 需要更新 Winner 名單，整理哪些 Prize 已經開獎 (userWinnerPrize.winnerPrize)，哪些尚未開獎 (userWinnerPrize.unOpenWinnerPrize)
export function setShouldUpdateUserWinnerList() {
    return {
        type: UPDATE_FLAGS,
        payload: {
            hasUserWinnerPrizeListReady: false
        }
    };
}

// 跳出恭喜領獎成功的 Popup 會用到 (Ex: 簽到成功)
export function setParticipantWinnerPopup({
    prizeUUID = '',
    entryUUID = '',
    isNoGetPrize = false
} = {}) {
    return {
        type: UPDATE_PARTICIPANT_PRIZE_POPUP,
        payload: {
            prizeUUID,
            entryUUID,
            isNoGetPrize: isNoGetPrize
        }
    };
}

export function clearParticipantWinnerPopup() {
    return {
        type: UPDATE_PARTICIPANT_PRIZE_POPUP,
        payload: {
            prizeUUID: '',
            entryUUID: '',
            isNoGetPrize: false
        }
    };
}

export function setAnimatingLotteries(animatingLotteries) {
    return {
        type: UPDATE_FLAGS,
        payload: {
            animatingLotteries
        }
    };
}

export function setInited() {
    return {
        type: UPDATE_FLAGS,
        payload: { hasInited: true }
    };
}

export function setUserStateInited() {
    return {
        type: UPDATE_FLAGS,
        payload: { hasUserStateInited: true }
    };
}

export function setErrorOnInit() {
    return {
        type: UPDATE_FLAGS,
        payload: { hasErrorOnInit: true }
    };
}

export function togglePrizeList(status) {
    return {
        type: UPDATE_FLAGS,
        payload: { isPrizeListOpen: status }
    };
}

export function setReJoin(status) {
    return {
        type: UPDATE_FLAGS,
        payload: { isReJoin: status }
    };
}
